import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import api from "../../../../api/axios";
import { COUNTRY_LIST } from "./countryList";

const TITLES = ["Mr", "Ms", "Mrs", "Miss", "Dr", "Prof"];
const GENDERS = ["Male", "Female", "Other"];
const ID_TYPES = [
  { value: "aadhar_card", label: "Aadhar Card" },
  { value: "passport", label: "Passport" },
  { value: "driving_license", label: "Driving License" },
  { value: "voter_id", label: "Voter ID" },
  { value: "pan_card", label: "Pan Card" },
  { value: "other", label: "Other" },
];

const AddGuest = ({ open, onClose, onAdded }) => {
  const [form, setForm] = useState({
    title: "",
    name: "",
    father_name: "",
    gender: "",
    dob: "",
    anniversary: "",
    nationality: "",
    country_code: "",
    mobile_no: "",
    email: "",
    country: "",
    state: "",
    city: "",
    zipcode: "",
    address: "",
    identity_type: "aadhar_card",
    identity_no: "",
    identity_comments: "",
    is_vip: false,
    is_blacklisted: false,
  });

  // files
  const [guestImageFile, setGuestImageFile] = useState(null);
  const [frontDocFile, setFrontDocFile] = useState(null);
  const [backDocFile, setBackDocFile] = useState(null);

  // previews
  const [imagePreview, setImagePreview] = useState(null);
  const [frontPreview, setFrontPreview] = useState(null);
  const [backPreview, setBackPreview] = useState(null);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) resetForm();
  }, [open]);

  const resetForm = () => {
    setForm({
      title: "",
      name: "",
      father_name: "",
      gender: "",
      dob: "",
      anniversary: "",
      nationality: "",
      country_code: "",
      mobile_no: "",
      email: "",
      country: "",
      state: "",
      city: "",
      zipcode: "",
      address: "",
      identity_type: "aadhar_card",
      identity_no: "",
      identity_comments: "",
      is_vip: false,
      is_blacklisted: false,
    });
    setGuestImageFile(null);
    setFrontDocFile(null);
    setBackDocFile(null);
    setImagePreview(null);
    setFrontPreview(null);
    setBackPreview(null);
  };

  const handleFile = (e, setter, previewSetter) => {
    const file = e.target.files[0];
    if (file) {
      setter(file);
      previewSetter(URL.createObjectURL(file));
    }
  };

  const validate = () => {
    if (!form.title) return Swal.fire("Title is required");
    if (!form.name.trim()) return Swal.fire("Name is required");
    if (!form.mobile_no.trim()) return Swal.fire("Mobile No is required");
    if (!form.email.trim()) return Swal.fire("Email is required");
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    const fd = new FormData();

    fd.append("property_code", localStorage.getItem("property_code"));

    Object.entries(form).forEach(([k, v]) => {
      fd.append(k, typeof v === "boolean" ? (v ? 1 : 0) : v);
    });

    if (guestImageFile) fd.append("guest_image", guestImageFile);
    if (frontDocFile) fd.append("front_doc", frontDocFile);
    if (backDocFile) fd.append("back_doc", backDocFile);

    try {
      setLoading(true);

      await api.post("/pms/guests", fd);

      Swal.fire("Guest Added Successfully", "", "success");

      if (onAdded) onAdded();
      onClose();
    } catch (err) {
      Swal.fire("Add Failed", err.response?.data?.message || "", "error");
    } finally {
      setLoading(false);
    }
  };

  if (!open) return null;

  return (
    <>
      <div className="modal-backdrop fade show" />

      <div className="modal d-block">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">

            <div className="modal-header">
              <h5>Add Guest</h5>
              <button className="btn-close" onClick={onClose} />
            </div>

            <form onSubmit={handleSubmit}>
              <div className="modal-body">

                <div className="row">
                  {/* Title */}
                  <div className="col-md-2 mb-2">
                    <label>Title</label>
                    <select
                      className="form-select"
                      value={form.title}
                      onChange={(e) =>
                        setForm({ ...form, title: e.target.value })
                      }
                    >
                      <option value="">Select</option>
                      {TITLES.map((t) => (
                        <option key={t}>{t}</option>
                      ))}
                    </select>
                  </div>

                  {/* Full Name */}
                  <div className="col-md-5 mb-2">
                    <label>Full Name</label>
                    <input
                      className="form-control"
                      value={form.name}
                      onChange={(e) =>
                        setForm({ ...form, name: e.target.value })
                      }
                    />
                  </div>

                  {/* Father Name */}
                  <div className="col-md-5 mb-2">
                    <label>Father Name</label>
                    <input
                      className="form-control"
                      value={form.father_name}
                      onChange={(e) =>
                        setForm({ ...form, father_name: e.target.value })
                      }
                    />
                  </div>

                  {/* Gender */}
                  <div className="col-md-3 mb-2">
                    <label>Gender</label>
                    <select
                      className="form-select"
                      value={form.gender}
                      onChange={(e) =>
                        setForm({ ...form, gender: e.target.value })
                      }
                    >
                      <option value="">Select</option>
                      {GENDERS.map((g) => (
                        <option key={g}>{g}</option>
                      ))}
                    </select>
                  </div>

                  {/* DOB */}
                  <div className="col-md-3 mb-2">
                    <label>DOB</label>
                    <input
                      type="date"
                      className="form-control"
                      value={form.dob}
                      onChange={(e) => setForm({ ...form, dob: e.target.value })}
                    />
                  </div>

                  {/* Anniversary */}
                  <div className="col-md-3 mb-2">
                    <label>Anniversary</label>
                    <input
                      type="date"
                      className="form-control"
                      value={form.anniversary}
                      onChange={(e) =>
                        setForm({ ...form, anniversary: e.target.value })
                      }
                    />
                  </div>

                  {/* Nationality */}
                  <div className="col-md-3 mb-2">
                    <label>Nationality</label>
                    <input
                      className="form-control"
                      value={form.nationality}
                      onChange={(e) =>
                        setForm({ ...form, nationality: e.target.value })
                      }
                    />
                  </div>

                  {/* Mobile */}
                  <div className="col-md-6 mb-2">
                    <label>Mobile No</label>
                    <div className="input-group">
                      <select
                        className="form-select"
                        style={{ maxWidth: "160px" }}
                        value={form.country_code}
                        onChange={(e) =>
                          setForm({ ...form, country_code: e.target.value })
                        }
                      >
                        <option value="">Code</option>
                        {COUNTRY_LIST.map((c) => (
                          <option key={c.code} value={c.code}>
                            {c.name} ({c.code})
                          </option>
                        ))}
                      </select>

                      <input
                        className="form-control"
                        value={form.mobile_no}
                        onChange={(e) =>
                          setForm({ ...form, mobile_no: e.target.value })
                        }
                      />
                    </div>
                  </div>

                  {/* Email */}
                  <div className="col-md-6 mb-2">
                    <label>Email</label>
                    <input
                      className="form-control"
                      type="email"
                      value={form.email}
                      onChange={(e) =>
                        setForm({ ...form, email: e.target.value })
                      }
                    />
                  </div>

                  {/* Country */}
                  <div className="col-md-4 mb-2">
                    <label>Country</label>
                    <input
                      className="form-control"
                      value={form.country}
                      onChange={(e) =>
                        setForm({ ...form, country: e.target.value })
                      }
                    />
                  </div>

                  {/* State */}
                  <div className="col-md-4 mb-2">
                    <label>State</label>
                    <input
                      className="form-control"
                      value={form.state}
                      onChange={(e) =>
                        setForm({ ...form, state: e.target.value })
                      }
                    />
                  </div>

                  {/* City */}
                  <div className="col-md-4 mb-2">
                    <label>City</label>
                    <input
                      className="form-control"
                      value={form.city}
                      onChange={(e) =>
                        setForm({ ...form, city: e.target.value })
                      }
                    />
                  </div>

                  {/* Zipcode */}
                  <div className="col-md-3 mb-2">
                    <label>Zipcode</label>
                    <input
                      className="form-control"
                      value={form.zipcode}
                      onChange={(e) =>
                        setForm({ ...form, zipcode: e.target.value })
                      }
                    />
                  </div>

                  {/* Address */}
                  <div className="col-md-12 mb-2">
                    <label>Address</label>
                    <textarea
                      className="form-control"
                      value={form.address}
                      onChange={(e) =>
                        setForm({ ...form, address: e.target.value })
                      }
                    />
                  </div>

                  {/* Identity Type */}
                  <div className="col-md-6 mb-2">
                    <label>Identity Type</label>
                    <select
                      className="form-select"
                      value={form.identity_type}
                      onChange={(e) =>
                        setForm({ ...form, identity_type: e.target.value })
                      }
                    >
                      {ID_TYPES.map((t) => (
                        <option key={t.value} value={t.value}>
                          {t.label}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Identity Number */}
                  <div className="col-md-6 mb-2">
                    <label>Identity Number</label>
                    <input
                      className="form-control"
                      value={form.identity_no}
                      onChange={(e) =>
                        setForm({ ...form, identity_no: e.target.value })
                      }
                    />
                  </div>

                  {/* Identity Comments */}
                  <div className="col-md-12 mb-2">
                    <label>Identity Comments</label>
                    <textarea
                      className="form-control"
                      value={form.identity_comments}
                      onChange={(e) =>
                        setForm({ ...form, identity_comments: e.target.value })
                      }
                    />
                  </div>

                  {/* VIP + Blacklist */}
                  <div className="col-12 d-flex gap-5">
                    <label>
                      <input
                        type="checkbox"
                        checked={form.is_vip}
                        onChange={() =>
                          setForm({ ...form, is_vip: !form.is_vip })
                        }
                      />{" "}
                      VIP
                    </label>

                    <label>
                      <input
                        type="checkbox"
                        checked={form.is_blacklisted}
                        onChange={() =>
                          setForm({
                            ...form,
                            is_blacklisted: !form.is_blacklisted,
                          })
                        }
                      />{" "}
                      Blacklisted
                    </label>
                  </div>

                  {/* FILE UPLOADS */}
                  <div className="row mt-4">
                    <div className="col-md-4">
                      <label>Guest Image</label>
                      <input
                        type="file"
                        className="form-control"
                        onChange={(e) =>
                          handleFile(e, setGuestImageFile, setImagePreview)
                        }
                      />
                      {imagePreview && (
                        <img
                          src={imagePreview}
                          alt=""
                          className="img-thumbnail mt-2"
                          style={{ width: 150 }}
                        />
                      )}
                    </div>

                    <div className="col-md-4">
                      <label>Front Document</label>
                      <input
                        type="file"
                        className="form-control"
                        onChange={(e) =>
                          handleFile(e, setFrontDocFile, setFrontPreview)
                        }
                      />
                      {frontPreview && (
                        <a
                          className="d-block mt-2"
                          href={frontPreview}
                          target="_blank"
                          rel="noreferrer"
                        >
                          Preview Front
                        </a>
                      )}
                    </div>

                    <div className="col-md-4">
                      <label>Back Document</label>
                      <input
                        type="file"
                        className="form-control"
                        onChange={(e) =>
                          handleFile(e, setBackDocFile, setBackPreview)
                        }
                      />
                      {backPreview && (
                        <a
                          className="d-block mt-2"
                          href={backPreview}
                          target="_blank"
                          rel="noreferrer"
                        >
                          Preview Back
                        </a>
                      )}
                    </div>
                  </div>

                </div>
              </div>

              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={onClose}>
                  Close
                </button>

                <button className="btn btn-primary" disabled={loading}>
                  {loading ? "Saving..." : "Save Guest"}
                </button>
              </div>

            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddGuest;
